<template>
  <div>
    <el-dialog :title="$t('text.modify')"
               :visible="isShowLoongConfig"
               width="600px"
               @close="handleDialog"
               :close-on-click-modal="false">
      <el-form ref="form" :model="form2" :rules="rules" label-width="200px">
        <el-date-picker v-model="form.createDate"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyyMMdd"
        />
        <el-button type="success" plain @click="read">{{ $t('text.search') }}</el-button>


        <!--        <el-form-item-->
        <!--            :label="$t('text.collectionFeeRate')"-->
        <!--            :label-width="formLabelWidth"-->
        <!--            prop="rate"-->
        <!--        >-->
        <!--          <el-input-->
        <!--              v-model="form2.rate"-->
        <!--              :placeholder="$t('message.inputCollectionFeeRate')"-->
        <!--              :disabled="!ROLE_TYPE.isManager()"-->
        <!--              @input="(val) => handleInput(val, 'rate')"-->
        <!--          ></el-input>-->
        <!--        </el-form-item>-->

        <hr>
<!--        <h2 style="text-align: center;"> loong1 配置  </h2>-->
<!--        <el-form-item :label="$t('text.date')" :label-width="formLabelWidth" prop="date">-->
<!--          <el-input v-model="form2.date" autocomplete="off" disabled></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item :label="$t('text.collectionAmount')" :label-width="formLabelWidth" prop="loongPayInAmount">-->
<!--          <el-input v-model="form2.loongPayInAmount" autocomplete="off"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item :label="$t('text.collectionRevenue')" :label-width="formLabelWidth" prop="loongPayInMerFee">-->
<!--          <el-input v-model="form2.loongPayInMerFee" autocomplete="off"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item :label="$t('text.collectionCost')" :label-width="formLabelWidth" prop="loongPayInFee">-->
<!--          <el-input v-model="form2.loongPayInFee" autocomplete="off"></el-input>-->
<!--        </el-form-item>-->

<!--        <el-form-item :label="$t('text.disbursementAmount')" :label-width="formLabelWidth" prop="loongPayOutAmount">-->
<!--          <el-input v-model="form2.loongPayOutAmount" autocomplete="off"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item :label="$t('text.disbursementRevenue')" :label-width="formLabelWidth" prop="loongPayOutMerFee">-->
<!--          <el-input v-model="form2.loongPayOutMerFee" autocomplete="off"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item :label="$t('text.disbursementCost')" :label-width="formLabelWidth" prop="loongPayOutFee">-->
<!--          <el-input v-model="form2.loongPayOutFee" autocomplete="off"></el-input>-->
<!--        </el-form-item>-->

<!--        <hr>-->

        <h2 style="text-align: center;"> BDKaro 其他配置 </h2>
        <el-form-item :label="$t('text.date')" :label-width="formLabelWidth" prop="date">
          <el-input v-model="form2.date" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('text.laborCost')" :label-width="formLabelWidth" prop="laborCost">
          <el-input v-model="form2.laborCost" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('text.localDailyCost')" :label-width="formLabelWidth" prop="localDailyCost">
          <el-input v-model="form2.localDailyCost" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('text.usdtWalletBalance')" :label-width="formLabelWidth" prop="usdtWalletBalance">
          <el-input v-model="form2.usdtWalletBalance" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('text.usdtRate')" :label-width="formLabelWidth" prop="usdtRate">
          <el-input v-model="form2.usdtRate" autocomplete="off"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialog">{{ $t('text.cancel') }}</el-button>
        <el-button
            type="primary"
            v-if="form.id === '' || form.id === null || form.id === undefined"
            @click="submit"
        >
          {{ $t('text.confirm') }}
        </el-button>

        <el-button
            type="primary"
            v-else
            @click="update"
        >
            {{ $t('text.confirm') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";

export default {
  props: {
    isShowLoongConfig: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let validateChannel = (rule, value, callback) => {
      const regex = /^[A-Za-z0-9]+$/;

      if (regex.test(value) || !value) {
        callback();
      }

      return callback(new Error(this.$t('message.invalidChannelOrderId')));
    };

    return {
      form: {
        id: "",
        configName: "PK_FinancialAffairsUpstreamStatistics",
        createDate: moment().format('YYYYMMDD')
      },
      rules: {
        toStatus: [{required: true, message: this.$t('message.orderStatusRequiredError'), trigger: "change"}],
        channelOrderId: [{validator: validateChannel, trigger: "change"}]
      },
      form2: {

        date: moment().format('YYYY-MM-DD'),

        loongPayInAmount: "0",
        loongPayInMerFee: "0",
        loongPayInFee: "0",

        loongPayOutAmount: "0",
        loongPayOutMerFee: "0",
        loongPayOutFee: "0",

        laborCost: "0",
        localDailyCost: "0",
        usdtWalletBalance: "0",
        usdtRate: "0",
      },
      formLabelWidth: "140px",
    };
  },
  methods: {
    reset() {
      this.form.id = "";
      this.form2 = {

        date:moment(this.form.createDate, 'YYYYMMDD').format('YYYY-MM-DD') +" 未设置",

        loongPayInAmount: "0",
        loongPayInMerFee: "0",
        loongPayInFee: "0",

        loongPayOutAmount: "0",
        loongPayOutMerFee: "0",
        loongPayOutFee: "0",

        laborCost: "0",
        localDailyCost: "0",
        usdtWalletBalance: "0",
        usdtRate:"0"
      };
    },
    handleDialog() {
      this.reset();
      this.$emit("update:isShowLoongConfig", false);
    },
    submit() {
      this.form2.date=moment(this.form.createDate, 'YYYYMMDD').format('YYYY-MM-DD')
      const params = {
        configName: "PK_FinancialAffairsUpstreamStatistics",
        configInfo: JSON.stringify({...this.form2}),
        dataTime: moment(this.form.createDate, 'YYYYMMDD').format('YYYY-MM-DD'),
      };
      this.$axios.post("/operational/financial/add", params).then((res) => {
        if (res.code === 200) {
          this.$notify({
            title: this.$t('text.prompt'),
            message: res.msg,
            type: "success"
          });
          this.$emit("update:isShowLoongConfig", false);
          this.$bus.$emit("refresh"); //通知刷新
        } else {
          this.$notify.error({
            title: this.$t('text.prompt'),
            message: res.msg
          });
        }
      });
    },
    update() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const params = {
            id: this.form.id,
            configName: "PK_FinancialAffairsUpstreamStatistics",
            configInfo: JSON.stringify({...this.form2}),
          };
          this.$axios.put("/operational/financial/update", params).then((res) => {
            if (res.code === 200) {
              this.$notify({
                title: this.$t('text.prompt'),
                message: res.msg,
                type: "success"
              });
              this.$emit("update:isShowLoongConfig", false);
              this.$bus.$emit("refresh"); //通知刷新
            } else {
              this.$notify.error({
                title: this.$t('text.prompt'),
                message: res.msg
              });
            }
          });
        }
      });
    },
    read() {
      let param = {
        configName: this.form.configName,
        createDate: this.form.createDate,
        endDate: this.form.createDate,
      };
      this.$axios
          .get('/operational/financial/query', {
            params: param
          })
          .then((res) => {
            if(res.data[0]){
              this.form2 = JSON.parse(res.data[0].configInfo);
              this.form.id = res.data[0].id;
            }else {
              this.reset()
            }
          });
    },
  },
  created() {
    this.$axios
        .get("/operational/financial/query", {
          params: {
            configName: "PK_FinancialAffairsUpstreamStatistics",
            createDate: this.form.createDate,
            endDate: this.form.createDate,
          }
        })
        .then((res) => {
          if(res.data[0] === undefined || res.data[0] === null || res.data[0] === "") {
            this.reset();
          }else {
            this.form2 = JSON.parse(res.data[0].configInfo);
            this.form.id = res.data[0].id;
          }
        });
  },
};
</script>
